import React, { FC } from 'react';

import { Typography } from '@mui/material';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { CardLabels } from '../../../../components/Card';
import { CategoryLabel } from '../../../../components/UI/CategoryLabel';
import { colorsPalette } from '../../../../theme';
import { DEFAULT_URL } from '../../const';
import useStyles from './styles';

interface GlossaryHitProps {
  slug: string;
  title: string;
  description: string;
  categories?: [any];
  videoUrl?: string;
}

const GlossaryHit: FC<GlossaryHitProps> = ({ slug, title, description, categories, videoUrl }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const cuttedDescription = description ? description.substring(0, 299) : '';

  return (
    <div className={classes.wrapper}>
      <CardLabels>
        <CategoryLabel
          wrapperClass={classes.cardLabel}
          name={t('page.discover.glossary')}
          textColor={colorsPalette.white}
          bgColor={colorsPalette.coral}
        />
        {categories &&
          categories.map((category) => (
            <CategoryLabel
              wrapperClass={classes.cardLabel}
              key={category?.id}
              name={category?.title}
              withDots={false}
            />
          ))}
        {Boolean(videoUrl) && (
          <CategoryLabel
            key={videoUrl}
            wrapperClass={classes.cardLabel}
            name={t('page.discover.videoClip')}
            textColor={colorsPalette.blueDark}
            bgColor={colorsPalette.yellow}
          />
        )}
      </CardLabels>
      <Typography className={classes.title} variant="h3">
        {title}
      </Typography>
      <Typography
        className={cn(classes.description, description?.length > 300 && classes.withDots)}
      >
        {cuttedDescription}
      </Typography>
      <Link className={classes.link} to={`${DEFAULT_URL}/glossary/${slug}`}>
        {t('page.discover.readMore')}
      </Link>
    </div>
  );
};

export default GlossaryHit;
